import axios from "axios";

import Config from "../../../config";

const v2_actionMetaVincularContaSocial = (canalId, data) => {
    let url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/meta/canal/${canalId}/vincular-conta-social`;
    return axios({
        method: "post",
        url: url,
        data: data
    });
};

export default v2_actionMetaVincularContaSocial;
